import React, { FC, ReactElement, HTMLAttributes } from "react";
import { cn } from "helpers/style";
import styles from "./CircleIcon.module.scss";

type Props = {
  icon: ReactElement;
  counter?: string | number;
  customCounter?: ReactElement;
  as?: string;
  background?: string;
  backgroundHover?: string;
  position?: "top-end" | "bottom";
  className?: string;
} & HTMLAttributes<HTMLElement>;

const positionMapping = {
  "top-end": "positionTopEnd",
  bottom: "positionBottom",
};

const CircleIcon: FC<Props> = ({
  icon,
  counter,
  customCounter,
  position = "top-end",
  background,
  as,
  className,
  children,
  ...rest
}: Props): ReactElement => {
  const element = as || "div";

  // на случай если есть два вложенных тега <a/> в одном блоке
  if (children) {
    return (
      <div className={cn([styles.circle, className])}>
        <span className={cn([styles.icon, styles.iconCenter])}>{icon}</span>
        {children}
        {customCounter && (
          <span
            className={cn([
              styles.customCounter,
              styles.customCounterIndex,
              styles[positionMapping[position]],
            ])}
          >
            {customCounter}
          </span>
        )}
      </div>
    );
  }

  return React.createElement(
    element,
    {
      className: cn([styles.circle, className]),
      style: { background },
      ...rest,
    },
    <>
      {customCounter && (
        <span
          className={cn([
            styles.customCounter,
            styles[positionMapping[position]],
          ])}
        >
          {customCounter}
        </span>
      )}
      {counter > 0 && (
        <span
          className={cn([styles.counter, styles[positionMapping[position]]])}
        >
          {counter}
        </span>
      )}
      <span className={styles.icon}>{icon}</span>
    </>
  );
};

export default CircleIcon;
